import { FormikActions, FormikValues } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { login } from '../actions/authentication';
import LoginForm from '../components/login-form';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class Login extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <LoginForm onLogin={this.doLogin} />
            </div>
        );
    }
    private doLogin = async (values: FormikValues, actions: FormikActions<any>) => {
        actions.setSubmitting(false);
        this.props.dispatch(await login(values.email, values.password));
    }

}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(Login)));



// WEBPACK FOOTER //
// ./src/containers/login.tsx